import React from "react";

import BlogCard from "./BlogCard";
import { blogs } from "./blogData";

import AnimatedHeading from "../../animations/AnimatedHeading";
import Noise from "../../animations/Noise";

const BlogGrid = () => {
  return (
    <section
      className="
        relative
        overflow-hidden
        py-14
        font-saira
        sm:py-14
        lg:py-16
      "
      style={{
        backgroundColor: "var(--bg-primary)",
        color: "var(--text-primary)",
      }}
    >
      {/* =========================================================
          Noise Texture
      ========================================================= */}
      <div className="pointer-events-none absolute inset-0 z-[1] opacity-40">
        <Noise
          patternSize={250}
          patternScaleX={2}
          patternScaleY={2}
          patternRefreshInterval={2}
          patternAlpha={15}
        />
      </div>

      {/* =========================================================
          Brand Glow
      ========================================================= */}
      <div
        className="
          pointer-events-none
          absolute
          left-1/2
          top-40
          h-[450px]
          w-[450px]
          -translate-x-1/2
          rounded-full
          blur-[140px]
          opacity-10
        "
        style={{
          backgroundColor: "var(--brand-primary)",
        }}
      />

      {/* =========================================================
          Main Container
      ========================================================= */}
      <div
        className="
          relative
          z-10
          mx-auto
          max-w-[1600px]
          px-6
          md:px-8
          lg:px-10
          xl:px-12
        "
      >
        {/* =======================================================
            Heading
        ======================================================= */}
        <div className="mx-auto mb-16 max-w-4xl text-center">
          <p
            className="
              text-sm
              font-bold
              uppercase
              tracking-[0.35em]
            "
            style={{
              color: "var(--brand-primary)",
            }}
          >
            [ OUR LATEST BLOGS ]
          </p>

          <AnimatedHeading
            as="h2"
            parts={["Explore Latest Insights, &", "Innovation"]}
            className="
              mt-5
              text-4xl
              font-semibold
              leading-tight
              md:text-5xl
              lg:text-6xl
            "
            style={{
              color: "var(--text-primary)",
            }}
          />
        </div>

        {/* =======================================================
            Blog Grid
        ======================================================= */}
        <div
          className="
            grid
            gap-8
            sm:grid-cols-2
            xl:grid-cols-3
            2xl:grid-cols-4
          "
        >
          {blogs.map((blog, index) => (
            <BlogCard
              key={blog.id}
              blog={blog}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;